import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { plainToClass } from 'class-transformer';
import { Notification } from './notification';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NotificationRepo {

    constructor(
        private http: HttpClient
    ) {
    }

    getNotifications(): Observable<Notification[]> {
        return this.http.get<Notification[]>(`${environment.apiBaseUrl}/courier/get-notifications`)
            .pipe(map(notifications => plainToClass(Notification, notifications)));
    }

    setNotificationsRead(notificationIds: string[]): Observable<unknown> {
        const body = notificationIds.map(id => ({ id, read: true}));
        return this.http.post(`${environment.apiBaseUrl}/courier/set-notifications-read`, { notifications:  body});
    }
}
